import React, { useState } from "react";
import { myGlobals, myUtilities } from "../Utils";
import InvoiceTableMUX from "./InvoiceTableMUX";
import PayableSumGridItemMUX from "./PayableSumGridItemMUX";
import { Subscribe } from "unstated";
import InvoiceDataContainer from "../Stores/InvoiceDataContainerStore";
import edit from "../Images/edit.png";
import { store as reduxStore } from "../redux/store";
import { hideConfirmAlertAction } from "../redux/actions/alertConfirmAction";
import AlertConfirmDialog from "../Components/Common/AlertConfirmDialog";
import PaymentDataContainer from "../Stores/PaymentDataContainerStore";

const PaymentSummaryUX = (props) => {

  const [showDrawer, setShowDrawerFlag] = useState(false);
  
  const handleEditDuringPayment = () => {
    if(myGlobals.flowName && myGlobals.flowName === "PROCESS_PARTIAL_INVOICES"){
      // partial giact sucess scenario
      reduxStore.dispatch(hideConfirmAlertAction());
      myGlobals.triggermodernACHFlow();
    } else {
	    myGlobals.invoiceSelectionAllowed = true;
	    myGlobals.resetPaymentMethods();
	    reduxStore.dispatch(hideConfirmAlertAction());
    }
	  }

  return (
		  <Subscribe to={[PaymentDataContainer]}>
	      {(payData) => (
    <Subscribe to={[InvoiceDataContainer]}>
      {(invData) => (
        <div className="payment-summary common-div">
          <div className="payment-summary-header">
            {myUtilities.accountSpecificLanguage(
              "Header.PaymentSummary",
              "Payment Summary"
            )}
          </div>
          <div className="payment-summ-container">
            <PayableSumGridItemMUX
              data={invData.insertCurrencySymbol()}
              msgKey="Header.currency"
              defaultMsg="Currency"
            />
              {!invData.state.paymentOnAccount && <PayableSumGridItemMUX
              className="countInvoices"
              data={
                invData.state.count +
                myUtilities.accountSpecificLanguage(
                  "PaymentSummary.CountInvoices",
                  " selected payable invoices"
                )
              }
              msgKey="Header.InvoiceQuantity"
              defaultMsg="Number of Invoices"
              additionalFields={
                invData.state.allowInvoiceExclusion && (
                		 <img
                         src={edit}
                         onClick={() => setShowDrawerFlag(true)}
                         className="edit-icon"
                       />
                )
              }
            ></PayableSumGridItemMUX>}

            <InvoiceTableMUX showDrawer= {showDrawer} setShowDrawerFlag = {setShowDrawerFlag}  />
            <AlertConfirmDialog
              onAlertConfirmDialogClick={handleEditDuringPayment}
            />
            <div className="bottom-grid-payment">
            <PayableSumGridItemMUX
            data={
              myUtilities.needCurrency("total") +
              myUtilities.toStringUtil(
                invData.state.totalValWithoutDiscount,
                "total"
              )
            }
            msgKey="Header.Modern.TIA"
            defaultMsg={myUtilities.accountSpecificLanguage(
              "AmountSummary.totalInvoiceAmount",
              "Total Invoice Amount"
            )}
          />
              {invData.state.totalDiscVal !== undefined &&
                myGlobals.isDiscountEnabled && (
                  <PayableSumGridItemMUX
                    data={
                      myUtilities.needCurrency("discountAmount") +
                      myUtilities.toStringUtil(
                        invData.state.totalDiscVal,
                        "discountAmount"
                      )
                    }
                    msgKey="Header.IncludesDiscountAmount"
                    defaultMsg="Total Discount"
                    className="applied-disc"
                  />
                )}
              <PayableSumGridItemMUX
              data={
                myUtilities.needCurrency("total") +
                myUtilities.toStringUtil(
                  invData.state.totalValWithoutDiscount - invData.state.totalDiscVal,
                  "total"
                )
              }
              msgKey="Header.Modern.TPA"
              defaultMsg="Total Payable Amount"
            />
              {payData.state.totalConvienceFee  && (
                <PayableSumGridItemMUX
                  data={
                    myUtilities.needCurrency("totalConvienceFee") +
                    myUtilities.toStringUtil(
                    		payData.state.totalConvienceFee,
                      "totalConvienceFee"
                    )
                  }
                  msgKey="Header.IncludesConvenienceFee"
                  defaultMsg="Convenience Fee"
                />
              )}
              {payData.state.totalSurchargeAmount && (
                <PayableSumGridItemMUX
                  data={
                    myUtilities.needCurrency("totalSurchargeAmount") +
                    myUtilities.toStringUtil(
                    		payData.state.totalSurchargeAmount,
                      "totalSurchargeAmount"
                    )
                  }
                  msgKey="Header.IncludesSurcharge"
                  defaultMsg="Surcharge"
                />
              )}
              {payData.state.totalLateFee !== undefined
               && payData.state.totalLateFee !== null
               && payData.state.totalLateFee > 0 
               && (
                <PayableSumGridItemMUX
                  data={
                    myUtilities.needCurrency("totalLateFee") +
                    myUtilities.toStringUtil(
                    		payData.state.totalLateFee,
                      "totalLateFee"
                    )
                  }
                  msgKey="Header.IncludesLateFee"
                  defaultMsg="Late Fee"
                />
              )}
              <PayableSumGridItemMUX
                data={
                  myUtilities.needCurrency("total") +
                  myUtilities.toStringUtil(invData.state.total, "total")
                }
                msgKey="Header.totalamt"
                defaultMsg="Grand Total"
              />
            </div>
            {invData.state.isCCEnabled === true &&
                invData.state.isSurchargeEnabledOnCC === true &&
                (myGlobals.paymentMethod === "CREDITCARD" ||
                  myGlobals.paymentMethod === "cc") ? (
                  <div className="text-danger small-font mt-2">
                    {(() => {
                      if ((invData.state.isSurchargeThroughAPIEnabled === true && invData?.state?.isSurchargeApplicableForTransaction !=undefined) || invData.state.isSurchargeEnabledOnCardBrand === true) {
                        if(invData.state.isSurchargeThroughAPIEnabled === true && invData.state.isSurchargeApplicableForTransaction === true){
                          if(invData?.state?.surchargePOEDisclosure != undefined && invData?.state?.surchargePOEDisclosure != null && invData?.state?.surchargePOEDisclosure != ""){
                            return invData.state.surchargePOEDisclosure;
                          }else{
                            return myUtilities.accountSpecificLanguage(
                              "Note.IncludesSurchargeNote",
                              "NOTE: Based on the card you add, there might be an additional surcharge fee added to the total transaction amount as applicable, which will be shown in the next step."
                            );
                          }
                        }else if(invData.state.isSurchargeThroughAPIEnabled === true && invData.state.isSurchargeApplicableForTransaction === false){
                          return "";
                        }
						 else if (invData.state.isSurchargeEnabledOnCardBrand === true) {
							  return myUtilities.accountSpecificLanguage(
								  "Note.IncludesSurchargeNote",
								  "NOTE: Based on the card you add, there might be an additional surcharge fee added to the total transaction amount as applicable, which will be shown in the next step."
							  );
						  }
                      }
                    })()}
                  </div>
                ) : null}
          </div>
        </div>
      )}
    </Subscribe>
	      )}
	      </Subscribe>
  );
};

export default PaymentSummaryUX;
